import IconTileContentLayout from "js/components/StudentTile/components/IconTileContentLayout";
import { Flex, Image, Text, Box } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import sleepingBell from "@/assets/studentTile/sleeping-bell.svg?url";
import { useClassroomLayoutStore } from "stores/v2/classroomLayoutStore";

export const ClassNotStarted: React.FC = () => {
	const { t } = useTranslation();
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex backgroundColor={"#F8F8F9"} flexDirection={"column"} align={"center"} justifyContent={"center"} height={"100%"}>
			<IconTileContentLayout>
				<Image src={sleepingBell} htmlHeight={56} htmlWidth={56} alt="" />
				<Box py={tileSize === "sm" ? "0px" : "8px"}>
					<Text fontWeight={"bold"} lineHeight={1.5}>
						{t("studentTile.classNotStartedTitle")}
					</Text>
					<Text lineHeight={1.5}>{t("studentTile.classNotStartedSubtitle")}</Text>
				</Box>
			</IconTileContentLayout>
		</Flex>
	);
};
